<template>
  <div>
    <a
      :href="link"
      target="_blank"
    >
      {{ link }}
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: {}
    }
  },
  computed: {
    link () {
      return this.data.link ?? '#'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
